import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { DifferenceSection } from './components/DifferenceSection';
import { ComparisonSection } from './components/ComparisonSection';
import { PainPointsSection } from './components/PainPointsSection';
import { LevelsSection } from './components/LevelsSection';
import { MapAnatomySection } from './components/MapAnatomySection';
import { ProgressionSection } from './components/ProgressionSection';
import { BonusSection } from './components/BonusSection';
import { PracticeSection } from './components/PracticeSection';
import { SamplesSection } from './components/SamplesSection';
import { BonusPackSection } from './components/BonusPackSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
interface AppProps {
  showCountdownBar?: boolean;
  samplesLayout?: 'carousel' | 'grid';
}
export function App({
  showCountdownBar = true,
  samplesLayout = 'carousel'
}: AppProps) {
  React.useEffect(() => {
    initMetaPixel();
  }, []);
  React.useEffect(() => {
    const name = 'facebook-domain-verification';
    const content = 'prolx231v7pi554iedwsy1x0w8nc3c';
    let tag = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', name);
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
  }, []);
  return <div className="min-h-screen w-full bg-stone-50 font-sans" data-id="element-0" data-mp="nxwv3et6z8sj">
      {showCountdownBar ? <UrgencyBar data-id="element-1" data-mp="swqd9kjfbnz1" /> : null}
      <Hero data-id="element-2" data-mp="3685nh1tcguh" />
      <main data-id="element-3" data-mp="35ynugqx9fzv">
        <StatsBand data-id="element-4" data-mp="35gkl05ue1ig" />
        <DifferenceSection data-id="element-5" data-mp="34x0pdwmt31s" />
        <ComparisonSection data-id="element-6" data-mp="38b50rouvmbv" />
        <PainPointsSection data-id="element-7" data-mp="3udaw269tuj3n" />
        <MapAnatomySection data-id="element-8" data-mp="3ubzrw5cgz9c0" />
        <LevelsSection data-id="element-9" data-mp="3uevsk1fpcc45" />
        <ProgressionSection data-id="element-10" data-mp="d4o09u01u88q" />
        <BonusSection data-id="element-11" data-mp="d3mlpfjtr3m9" />
        <PracticeSection data-id="element-12" data-mp="d45ti3frgbmk" />
        <SamplesSection layout={samplesLayout} data-id="element-13" data-mp="d2bjhk6123x9" />
        <BonusPackSection data-id="element-14" data-mp="86mev2f5hwu3" />
        <OfferSection data-id="element-15" data-mp="86cmx9ajpflr" />
        <GuaranteeSection data-id="element-16" data-mp="83qivjmv5i8a" />
        <TestimonialsSection data-id="element-17" data-mp="3gkv1zuywlvev" />
        <FaqSection data-id="element-18" data-mp="3gm61hilbgh06" />
        <FinalCtaSection data-id="element-19" data-mp="3gja5w0wxy4ew" />
      </main>
      <Footer data-id="element-20" data-mp="3bmtjbb5e3y3x" />
    </div>;
}